import styled from 'styled-components';

import type { FontWeight, Typography } from '~/shared/theme/font';
import type { RemoveSuffix } from '~/shared/utils/typescript';

const BaseText = styled.div<{ weight?: RemoveSuffix<FontWeight, '-weight'> }>`
  ${({ weight }) => weight && `font-weight: var(--${weight}-weight)`};
`;

export const fontSizeCss = (sizeName: Typography) => `font-size: var(--${sizeName});`;

export const SmallText = styled(BaseText)`
  ${fontSizeCss('small-text')}
`;

export const RegularText = styled(BaseText)`
  ${fontSizeCss('normal-text')}
`;

export const MediumText = styled(BaseText)`
  ${fontSizeCss('medium-text')}
`;

export const LargeText = styled(BaseText)`
  ${fontSizeCss('large-text')}
`;

export const Headline6 = styled(BaseText)`
  ${fontSizeCss('headline6')}
`;

export const Headline5 = styled(BaseText)`
  ${fontSizeCss('headline5')}
`;

export const Headline4 = styled(BaseText)`
  ${fontSizeCss('headline4')}
`;

export const Headline3 = styled(BaseText)`
  ${fontSizeCss('headline3')}
`;

export const Headline2 = styled(BaseText)`
  ${fontSizeCss('headline2')}
`;

export const Headline1 = styled(BaseText)`
  ${fontSizeCss('headline1')}
`;
